import { useEffect, useRef, useState, useCallback } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./TechMain.css";

const TechMain = () => {
  const cardsRef = useRef([]);
  const stackAreaRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    if (isMobile) {
        AOS.init({
            duration: 900,
            easing: "ease-out",
            once: true,
            offset: 30,
        });
        AOS.refresh();
    }
}, [isMobile]);


  const cardData = [
    {
      id: "ignite",
      sub: "IGNITE®",
      title: "Qualidade Tecidual",
      desc: "Plataforma moderna que otimiza firmeza e retração da pele usando radiofrequência de forma precisa e segura.",
    },
    {
      id: "morpheus",
      sub: "Morpheus®",
      title: "RF Fracionada",
      desc: "Aprofunda o tratamento com energia controlada, estimulando colágeno e melhorando textura e firmeza.",
    },
    {
      id: "quantum",
      sub: "Quantum®",
      title: "RF Inteligente",
      desc: "Radiofrequência com monitoramento automático que trata diferentes profundidades com segurança e eficiência.",
    },
    {
      id: "safer-vaser",
      sub: "SAFER/VASER®",
      title: "Alta Precisão",
      desc: "Ultrassom que preserva vasos, reduz sangramento e melhora retração da pele durante a lipoaspiração.",
    },
    {
      id: "one-step",
      sub: "One S.T.E.P.™",
      title: "Trauma Reduzido",
      desc: "Técnica moderna que combina lipoaspiração com laser, auxiliando na remoção da gordura e contração da pele.",
    },
  ];

  const rotateCards = useCallback(() => {
    const cards = cardsRef.current;
    let angle = 0;

    cards.forEach((card, index) => {
      if (!card) return;

      if (isMobile) {
        card.style.transform = "none";
        card.style.zIndex = "auto";
        return;
      }

      if (card.classList.contains("away")) {
        card.style.transform = "translateY(-120vh) rotate(-48deg)";
      } else {
        card.style.transform = `rotate(${angle}deg)`;
        angle -= 10;
        card.style.zIndex = cards.length - index;
      }
    });
  }, [isMobile]);

  const handleScroll = useCallback(() => {
    if (isMobile) return;

    const cards = cardsRef.current;
    const stackArea = stackAreaRef.current;

    if (!stackArea) return;

    const distance = window.innerHeight * 0.8;

    const topVal = stackArea.getBoundingClientRect().top;
    const index = Math.floor(-1 * (topVal / distance + 1));

    cards.forEach((card, i) => {
      if (!card) return;

      if (i <= index) {
        card.classList.add("away");
      } else {
        card.classList.remove("away");
      }
    });

    rotateCards();
  }, [isMobile, rotateCards]);

  useEffect(() => {
    let resizeTimer;

    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        setIsMobile(window.innerWidth <= 768);
      }, 150);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(resizeTimer);
    };
  }, []);

  useEffect(() => {
    rotateCards();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll, rotateCards]);

  return (
    <div className="stack-area" ref={stackAreaRef}>
      <div className="main-tech-card-left">
        <div className="tech-title" data-aos={isMobile ? "fade-up" : null}>Tecnologia e Experiência Otimizada</div>

        <div className="sub-title" data-aos={isMobile ? "fade-up" : null}>
          Como seria uma cirurgia plástica focada em <b>minimizar o trauma</b> e{" "}
          <b>acelerar sua recuperação</b>? Nossas tecnologias avançadas buscam
          transformar a experiência pós-operatória, oferecendo{" "}
          <b>mais conforto</b> e <b>menos interrupções</b> na sua vida.
          <div className="tech-button">
            <a
              href="/tecnologias"
              className="custom-button"
              aria-label="Saiba mais sobre nossas tecnologias"
            >
              Saiba mais aqui
            </a>
          </div>
        </div>
      </div>

      <div className="main-tech-card-right">
        {cardData.map((item, i) => (
          <div
            key={item.id}
            className="cards-on-deck"
            data-aos={isMobile ? "fade-up" : null}
            ref={(el) => (cardsRef.current[i] = el)}
            role="article"
            aria-label={`${item.sub}: ${item.title}`}
          >
            <div className="sub">{item.sub}</div>
            <div className="content">{item.title}</div>
            <div className="desc">{item.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TechMain;
